/*
 * @Description: 
 * @Author: xiaoyao
 * @since: 2020-05-08 11:49:42
 * @LastAuthor: xiaoyao
 * @lastTime: 2020-05-08 14:51:32
 */
/*
 * @Description: 
 * @Author: xiaoyao
 * @since: 2020-03-04 10:23:58
 * @LastAuthor: xiaoyao
 * @lastTime: 2020-03-23 16:58:55
 */
import Vue from 'vue'
import {
    NODE_ID,
} from '@/store/mutation-types'

const organization = {
    state: {
        //选中节点ID
        node_id: '',
    },
    mutations: {
        SET_NODE_ID: (state, node_id) => {
            state.node_id = node_id
            Vue.ls.set(NODE_ID, node_id)
        },
    },
    actions: {
        setNodeID({ commit }, id) {
            commit('SET_NODE_ID', id)
        },
        
    }
}

export default organization


// WEBPACK FOOTER //
// ./src/store/modules/organization.js